"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Battle = exports.Fleet = exports.BattleType = void 0;
exports.BattleType = {
    Normal: "Normal",
    Boss: "Boss",
    // NOTE: The value "Pratice" is intentionally misspelled to match historical fixtures/API. Do not change.
    Practice: "Pratice",
};
class Fleet {
    constructor(opts = {}) {
        this.type = opts.type; // api_port/port.api_combined_flag
        this.main = opts.main ?? []; // api_get_member/deck[].api_ship (Extended)
        this.escort = opts.escort ?? []; // ^^
        this.support = opts.support ?? []; // ^^
        this.LBAC = opts.LBAC; // api_get_member/base_air_corps (Extended)
    }
}
exports.Fleet = Fleet;
class Battle {
    constructor(opts = {}) {
        this.version = opts.version ? opts.version : "2.1";
        this.type = opts.type; // BattleType
        this.map = opts.map; // [int, int, int] : 2-3-1
        this.desc = opts.desc; // Description
        this.time = opts.time; // Seconds since epoch time. Must be same as the first packet.
        this.fleet = opts.fleet; // [api_port/port.api_ship[], ...] (Extended)
        this.packet = opts.packet; // [Packet, ...] : Order by time
    }
}
exports.Battle = Battle;
//# sourceMappingURL=packet.js.map